import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import Echo from 'laravel-echo';
import { BehaviorSubject } from 'rxjs';

import { ResultData } from '@app/core/_common/model';
import { AuthService } from '@app/core/auth';
import { environment } from '@app/env-service';
import { FeatureToggleService } from '@app/shared/services/feature-toggle.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  Echo :any;
  url :string = environment.url;
  lastUpdate :number; // = +new Date('2019-09-09');
  params :any = {};

  private readonly _notifications = new BehaviorSubject<any>(<any>{
    data: [],
    unread_count: 0,
  });
  public notifications$ = this._notifications.asObservable();

  public gettingRecords :boolean = false;

  #didInit :boolean = false;

  constructor(
    private _feature :FeatureToggleService,
    private authService :AuthService,
    private http :HttpClient,
  ) {
    this.init();
  }

  init() {
    if (!this._feature.isActive('SWITCH_ws_notifications')) {
      return;
    }
    if (this.#didInit) {
      return;
    }

    this.#didInit = true;

    const config :any = environment.ECHO_CONFIG;
    config.auth = {
      headers: {
        Authorization: 'Bearer ' + this.authService.getAccessToken(),
      },
    };

    this.Echo = new Echo(config);

    const user = this.authService.getUser();
    const channel = 'team.' + user.id;

    this.Echo.private(channel).notification((notification) => {
      this.notifReceived(notification);
    });

    this.getUnread({});
  }

  notifReceived(e) {
    this.getUnread(this.params);
    this.playAudio();
  }

  playAudio() {
    const audio = new Audio('/assets/media/sounds/beyond-doubt.ogg');
    audio.play();
  }

  markNotifRead(id :string) {
    return this.http
      .post(`${this.url}/notifications`, {
        id: id,
      })
      .subscribe((resp :any) => {
        const notif = this._notifications.getValue();
        const idx = notif.data.findIndex((row) => {
          return row.id == id;
        });
        if (idx || idx > 0) {
          notif.data[idx].read_at = new Date();
        }
        notif.unread_count -= 1;
        this._notifications.next(notif);
      });
  }

  markAsRead() {
    const notif = this._notifications.getValue();
    if (notif.unread_count == 0) {
      return;
    }

    return this.http
      .post(`${this.url}/notifications`, {})
      .subscribe((resp :any) => {
        notif.data.forEach((n) => {
          n.read_at = new Date();
        });
        notif.unread_count = 0;
        this._notifications.next(notif);
      });
  }

  getUnread(params :any) {
    this.gettingRecords = true;
    if (this.lastUpdate) {
      params.last_update = this.lastUpdate;
    }
    this.params = params;

    return this.http
      .get(`${this.url}/notifications`, { params: params })
      .subscribe((resp :any) => {
        this.lastUpdate = resp.dt;
        resp.data.forEach((n) => {
          const dt = new Date(n.created_at);

          n.created_at = dt;
        });
        const notif = this._notifications.getValue();
        notif.data = resp.data.concat(notif.data);
        notif.unread_count += resp.unread_count;
        this._notifications.next(notif);
        this.gettingRecords = false;
      });
  }
}
